<template>
  <div id="home-page" class="home-page-container">
    <b-modal id="modal-1" size="lg" v-model="showDataRetentionModal" :hideHeader="true" :no-close-on-backdrop="true" :no-close-on-esc="true" @ok="NotificationViewed()">
      <p class="my-4 mt-6">
        Effective <b>February 1, 2026, Azira will retain and support data for the most recent 24-months, in addition to the ongoing quarter.</b> For example, on February 1, 2026, data will be available from January 1, 2024 through December 31, 2025, along with current January 2026 data. By June 1, 2026, data availability will shift to April 1, 2024 through May 31, 2026 along with current June 2026 data. This rolling schedule will continue each quarter.
      </p>
      <p class="my-4">
        This update aligns Azira’s data policies with best practices for privacy and data protection of retaining data only for the minimum duration of business use case - helping ensure we continue to provide the most accurate, compliant, and up-to-date information. Further, our analysis shows that this change will not impact the majority of your requirements.
      </p>
      <p class="my-4">
        As always, our support team is here to assist you with any questions or concerns you might have regarding this change. Please don’t hesitate to reach out to us at 
        <a href="mailto:support@azira.com">support@azira.com</a>.
      </p>
      <p class="my-4">
        Thank you for your understanding and continued partnership.
      </p>
      <p class="my-4">
        Sincerely,<br />
        The Azira Team
      </p>
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="primary" @click="ok()">
          Accept
        </b-button>        
      </template>
    </b-modal>    
    <div v-if="showBanner">
    <b-alert show dismissible variant="warning" style="position: absolute; z-index: 1000;width: calc( 100vw - 100px )">
      <!--We are experiencing issues which may result in processing delays for Pinnacle Reports and Datasets.
      We apologize for the inconvenience.-->
      <!-- The queue is active and running. However, there is a higher than normal volume of jobs, therefore completion times may be delayed. -->
      Our site is currently undergoing scheduled maintenance to the Data API product to improve your experience and security. Expected down time is roughly seven hours and this banner will be removed to indicate the maintenance has been completed. 
      <br />
      Thank you for your patience and please reach out to 
      <a href="mailto:support@azira.com">support@azira.com</a>
      with any concerns or questions.
    </b-alert>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { GetMixin } from "pinnacle-lib";
export default {
  mixins: [GetMixin],
  data() {
    return {
      showBanner: false,
      showDataRetentionModal: false
    };
  },
  mounted() {
    //console.log('HomePage mounted');
    this.loadBanners();
    this.loadNotifications();
  },
  methods: {
    async loadBanners() {   
      let urlStr = `${process.env.VUE_APP_PINNACLE_API}/v2/active-banners`;
      let data = await this.getFromURL(urlStr, { });

      //console.log(data);
      if (data?.records?.length > 0) {
        this.showBanner = true;
      } else {
        this.showBanner = false;
      }
      
    },
    async loadNotifications() {
      let urlStr = `${process.env.VUE_APP_PINNACLE_API}/v2/notification-view?notification_type=data-retention-policy-update`;
      let data = await this.getFromURL(urlStr, { });

      console.log('notification view', data);

      if (data?.records?.length < 1) {
        this.showDataRetentionModal = true;
      }
    },
    async NotificationViewed() {
      let urlStr = `${process.env.VUE_APP_PINNACLE_API}/v2/notification-viewed?notification_type=data-retention-policy-update`;
      let data = await this.getFromURL(urlStr, { });

      console.log('notification view posted', data);
    }
  }
}
</script>

<style lang="scss" scoped>
.home-page-container {
  overflow: auto;
}
</style>